import type { SxProps, Theme } from '@mui/material/styles';

const indicationComparisonStyles = {
  titleSection: {
    p: 2,
    borderBottom: 1,
    borderColor: 'divider',
    flexShrink: 0
  },
  content: {
    flex: 1,
    overflowY: 'auto',
    p: 2
  },
  tableContainer: {
    mb: 2
  },
  comparisonTable: {
    tableLayout: 'fixed',
    width: '100%'
  },
  tableHeaderRow: {
    bgcolor: 'grey.100'
  },
  tableHeaderCellField: {
    fontWeight: 700,
    width: '28%',
    wordBreak: 'break-word',
    verticalAlign: 'top'
  },
  tableHeaderCellPrev: {
    fontWeight: 700,
    width: '36%',
    wordBreak: 'break-word',
    verticalAlign: 'top'
  },
  tableHeaderCellCurr: {
    fontWeight: 700,
    width: '36%',
    wordBreak: 'break-word',
    verticalAlign: 'top'
  },
  stubRow: {
    bgcolor: 'grey.50'
  },
  stubCell: {
    fontWeight: 600,
    wordBreak: 'break-word',
    verticalAlign: 'top'
  },
  studyPaper: {
    mb: 2,
    borderRadius: 1,
    borderColor: 'grey.300'
  },
  studyPaperHeader: {
    px: 2,
    py: 1,
    fontWeight: 700,
    bgcolor: 'grey.100',
    borderBottom: 1,
    borderColor: 'divider',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  studyRow: {
    '&:nth-of-type(even)': { bgcolor: 'grey.50' }
  },
  studyCellTh: {
    width: '28%',
    fontWeight: 600,
    wordBreak: 'break-word',
    verticalAlign: 'top'
  },
  studyCellPrev: {
    width: '36%',
    wordBreak: 'break-word',
    verticalAlign: 'top'
  },
  studyCellCurr: {
    width: '36%',
    wordBreak: 'break-word',
    verticalAlign: 'top'
  },
  actionsBar: {
    display: 'flex',
    justifyContent: 'center',
    gap: 2,
    p: 2,
    borderTop: 1,
    borderColor: 'divider',
    flexShrink: 0
  }
} as const satisfies Record<string, SxProps<Theme>>;

export default indicationComparisonStyles;
